import {Config} from '../config/param';
import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import * as moment from "moment";

@Injectable({
  providedIn: 'root'
})
export class TableListeService {
  private tmpData: any;

  constructor(private http: HttpClient) {
  }

  getList() {
    return this.http.get(`${Config.API_URL}/thesaurus/list`);
  }

  getListLike(dataTemp: any) {
    const data = {
      ...dataTemp,
      dateDu: dataTemp.dateDu !== '' ? `${dataTemp.dateDu.split('-')[2]}-${dataTemp.dateDu.split('-')[1]}-${dataTemp.dateDu.split('-')[0]}` : '',
      dateAu: dataTemp.dateAu !== '' ? `${dataTemp.dateAu.split('-')[2]}-${dataTemp.dateAu.split('-')[1]}-${dataTemp.dateAu.split('-')[0]}` : '',
    };
    return this.http.post(`${Config.API_URL}/thesaurus/getListLike`, {data});
  }

  getThesaurusById(thesaurus_id) {
    return this.http.get(`${Config.API_URL}/thesaurus/getById/`, {params: new HttpParams().set('thesaurus_id', thesaurus_id)});
  }

  getPdfContentById(id: number) {
    return this.http.post(`${Config.API_URL}/thesaurus/getPdfContentById`, {id});
  }

  getRelationList(IdThes) {
    return this.http.post(`${Config.API_URL}/thesaurus/getRelationList`, {IdThes});
  }
}
